import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'app/main/shared/shared/shared.module';
import { TranslocoDirective } from '@jsverse/transloco';
import { IframeableSelectTemplateComponent } from './iframeable-select-template.component';
import { IFrameAbleGuard } from 'app/auth/helpers/iframeable.guard';
import { SessionGuard } from 'app/auth/helpers/session.guard';
import { CrmLoginComponent } from 'app/crm-login/crm-login.component';


const routes: Routes = [
  {
    path: '',
    canActivate:[IFrameAbleGuard],
    children: []
  },
  {
    path: 'select-template',
    component: IframeableSelectTemplateComponent,
    data: { animation: 'zoomIn' },
  },
  {
    path: 'login',
    component: CrmLoginComponent,
    data: { animation: 'auth', loginVia : 'iframeable' },
    canActivate: [SessionGuard]
  },
];


@NgModule({ 
  declarations: [
    IframeableSelectTemplateComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    NgbModule,
    CoreCommonModule,
    NgSelectModule,
    FormsModule,
    SharedModule,
    TranslocoDirective
  ],
  exports: [
    IframeableSelectTemplateComponent
  ]
})
export class IframeableModule {}
